import { agruparLicencias, type LicenciaBiblioteca } from './queries';

/** Casillas de licencias agrupadas (Activas / Para instructores / Inactivas). */
export function ElegirLicencias({
  licencias,
  elegidas,
  onCambio,
  deshabilitado = false,
}: {
  licencias: LicenciaBiblioteca[];
  elegidas: Set<number>;
  onCambio: (id: number, marcada: boolean) => void;
  deshabilitado?: boolean;
}) {
  return (
    <div className="max-h-80 space-y-4 overflow-y-auto pr-1">
      {agruparLicencias(licencias).map((g) => (
        <fieldset key={g.titulo}>
          <legend className="mb-2 text-xs font-extrabold tracking-wide text-texto-3 uppercase">
            {g.titulo}
          </legend>
          <div className="grid gap-1.5 sm:grid-cols-2">
            {g.items.map((m) => (
              <label key={m.id} className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  className="h-4 w-4 accent-[var(--color-azul-600)]"
                  checked={elegidas.has(m.id)}
                  disabled={deshabilitado}
                  onChange={(e) => onCambio(m.id, e.target.checked)}
                />
                <span>
                  {m.name} <span className="text-xs text-texto-3">({m.itemsCount})</span>
                </span>
              </label>
            ))}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
